// Component: brokerCapabilities.js
// Purpose: Broker-list normalization helpers (2026-07-06, BIS migration 008) — extract the broker
//          list from the DeeTrade envelope and key it by broker_id. Consumed by SmartOrderForm
//          (manual) and TradeExecutionStep (algo strategy builder).
//
//! loop-back-4 (order-instrument-normalization) — the broker-keyed product/order-type gate
//   (PRODUCT_GATE_KEYS / isProductAllowed / isOrderTypeAllowed / buildCapabilityGate) was REMOVED:
//   it had ZERO production callers (grep-verified across frontend/src) after the class-keyed
//   FAIL-CLOSED gate in instrumentClassCapabilityGate.js replaced it (R6.1.x). Leaving the dead
//   broker-keyed parallel gate was a mis-wire landmine (a future dev could wire the wrong gate) and
//   its unit test had gone red when the stale MARGIN:'NRML' key was dropped in loop-back-3. Deleted
//   with its tests per feedback_decommission_grep_tests_before_delete (whole test tree grep'd).
//
//! broker-capability-single-source (Part A) — buildBrokerMaps no longer returns a `metas`
//   (broker_metadata) map: both call sites (SmartOrderForm.jsx, TradeExecutionStep.jsx) already
//   discarded it, and broker_metadata.order_types/api_capabilities is being decommissioned as a
//   capability source. The class-keyed manifest (services.brokerAccounts.getBrokerCapabilities ->
//   instrumentClassCapabilityGate.js) is the single source. `.names` is retained (still consumed
//   by both forms). Removed with its test assertions per feedback_decommission_grep_tests_before_delete.

//! GET /brokers/ (list) returns the DeeTrade envelope {status, data: [...], total} while
//! GET /brokers/{id} returns the bare object — the forms' old `res.data.results` fallback
//! matched NEITHER, so the broker list was silently [] and no gating ever fired.
export const extractBrokerList = (respData) => {
  if (Array.isArray(respData)) return respData;
  if (Array.isArray(respData?.data)) return respData.data;
  if (Array.isArray(respData?.results)) return respData.results;
  if (Array.isArray(respData?.data?.results)) return respData.data.results;
  return [];
};

//! BIS /brokers items carry `broker_id` (NOT `id`) — keying on b.id silently maps
//! everything under `undefined` and every capability lookup misses (form allows all).
export const buildBrokerMaps = (brokerList) => {
  const names = {};
  (brokerList || []).forEach((b) => {
    const bid = b.broker_id ?? b.id;
    if (bid == null) return;
    const name = b.display_name || b.broker_name || b.name || `Broker ${bid}`;
    names[bid] = name;
    names[String(bid)] = name;
  });
  return { names };
};

// (product/order-type/multi-account capability gate removed — see the header note; the class-keyed
//  gate in instrumentClassCapabilityGate.js is the live, fail-closed replacement.)
